class WLSMegamenu extends HTMLElement {
    constructor() {
        super();
        this.id = this.getAttribute('id');
        this.menuItem = Array.from(document.querySelectorAll('.wls-header__menu-wrapper--desk a'))
            .find(a => a.innerHTML.includes(this.id));

        this._initialized = false;
        this._mobileInitialized = false;
    }

    connectedCallback() {
        if (!this._initialized) {
            this._initialized = true;
            this.headerFunctionality();
        }

        this.headerFunctionalityMobile();
    }

    headerFunctionality() {
        const header = document.querySelector('.wls-header');
        const headerWrapper = document.querySelector('.wls-header .wls-wrapper');

        if (headerWrapper && headerWrapper.parentNode && !this._inserted) {
            headerWrapper.parentNode.insertBefore(this, headerWrapper.nextSibling);
            this._inserted = true;
        }

        if (this.menuItem) {
            this.menuItem.addEventListener('click', () => {
                this.classList.toggle('open');
                this.lockBodyScroll();
            });
        }
    }

    headerFunctionalityMobile() {
        if (window.innerWidth < 1025 && !this._mobileInitialized) {
            const mobileMegamenuTrigger = document.querySelector('.js-wls-header-megamenu-trigger');
            this._mobileInitialized = true;

            if (this.classList.contains('megamenu-mobile')) {
                
                if (mobileMegamenuTrigger) {
                    mobileMegamenuTrigger.addEventListener('click', () => {
                        mobileMegamenuTrigger.classList.toggle('active');
                        this.classList.toggle('open');
                        this.lockBodyScroll();
                    });
                }
            }
            else {
                this.style.display = 'none';
                if (mobileMegamenuTrigger) {
                    mobileMegamenuTrigger.style.display = 'none';
                }
            }

        }
    }

    lockBodyScroll() {
        if (this.classList.contains('open')) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }
    }

}

if (customElements.get('wls-megamenu') === undefined) {
    customElements.define('wls-megamenu', WLSMegamenu);
}
